/**
 * Doubleheader resolution rule (Jack, 2026-07-23): whenever a player-level
 * surface must pick ONE of a player's per-game entries, it resolves to the
 * NEXT game — before G1's first pitch that's G1; once G1 has commenced,
 * pregame of G2 resolves to G2. When every game has commenced (or nothing is
 * datable), the latest entry wins.
 */
export function resolveNextGameEntry<T extends { game?: { commenceTime?: string } }>(
  entries: readonly T[],
  now: Date = new Date(),
): T | undefined {
  if (entries.length === 0) return undefined;
  if (entries.length === 1) return entries[0];

  const dated = entries
    .map(entry => {
      const ms = entry.game?.commenceTime ? new Date(entry.game.commenceTime).getTime() : NaN;
      return { entry, ms };
    })
    .filter(({ ms }) => Number.isFinite(ms))
    .sort((a, b) => a.ms - b.ms);
  if (dated.length === 0) return entries[entries.length - 1];

  const nowMs = now.getTime();
  return dated.find(({ ms }) => ms > nowMs)?.entry ?? dated[dated.length - 1].entry;
}
